// 全局状态 (zustand): 主题、语言、列表、选择模式
import { create } from 'zustand';

export type Theme = 'dark' | 'light';
export type Lang = 'en' | 'zh';
export type Filter = 'all' | 'image' | 'video';

interface AppState {
  theme: Theme;
  lang: Lang;
  filter: Filter;
  inSelectMode: boolean;
  selected: Set<string>;
  setTheme: (t: Theme) => void;
  toggleTheme: () => void;
  setLang: (l: Lang) => void;
  setFilter: (f: Filter) => void;
  enterSelect: (uuid: string) => void;
  toggleSelect: (uuid: string) => void;
  exitSelect: () => void;
  clearSelected: () => void;
  selectAll: (uuids: string[]) => void;
}

function getInitialTheme(): Theme {
  const s = localStorage.getItem('sv_theme');
  if (s === 'light' || s === 'dark') return s;
  return window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
}
function getInitialLang(): Lang {
  const s = localStorage.getItem('sv_lang');
  if (s === 'zh' || s === 'en') return s;
  return (navigator.language || '').startsWith('zh') ? 'zh' : 'en';
}

export const useStore = create<AppState>((set, get) => ({
  theme: getInitialTheme(),
  lang: getInitialLang(),
  filter: 'all',
  inSelectMode: false,
  selected: new Set(),
  setTheme: (t) => { localStorage.setItem('sv_theme', t); document.documentElement.dataset.theme = t; set({ theme: t }); },
  toggleTheme: () => get().setTheme(get().theme === 'dark' ? 'light' : 'dark'),
  setLang: (l) => { localStorage.setItem('sv_lang', l); set({ lang: l }); },
  setFilter: (f) => set({ filter: f, inSelectMode: false, selected: new Set() }),
  enterSelect: (uuid) => set({ inSelectMode: true, selected: new Set([uuid]) }),
  toggleSelect: (uuid) => {
    const sel = new Set(get().selected);
    if (sel.has(uuid)) sel.delete(uuid); else sel.add(uuid);
    set({ selected: sel });
    if (sel.size === 0) set({ inSelectMode: false });
  },
  exitSelect: () => set({ inSelectMode: false, selected: new Set() }),
  clearSelected: () => set({ selected: new Set() }),
  selectAll: (uuids) => set({ selected: new Set(uuids) }),
}));
